import { createFileRoute } from "@tanstack/react-router";
import { SeoPage } from "@/components/SeoPage";
import { faqJsonLd } from "@/lib/seo-jsonld";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26, LAST_REVIEWED } from "@/lib/official-sources";

const faqs = [
  { q: "Kan en food truck få serveringstillstånd?", a: "Ja, men det krävs i regel ett tillfälligt tillstånd för varje plats och tillfälle, eller ett cateringtillstånd kopplat till slutna sällskap." },
  { q: "Vilken kommun söker jag hos?", a: "Du söker hos den kommun där serveringen ska ske. Verkar food trucken i flera kommuner krävs separat tillstånd i varje kommun." },
  { q: "Behövs kunskapsprov?", a: "Ja, samma kunskapsprov i alkohollagen gäller även för mobil servering." },
];

export const Route = createFileRoute("/serveringstillstand-food-truck")({
  component: () => (
    <SeoPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Guider", to: "/serveringstillstand-och-kunskapsprov" },
        { label: "För food truck" },
      ]}
      title="Serveringstillstånd för food truck"
      intro="Så får du serveringstillstånd för food truck och mobil servering – tillfälliga tillstånd, krav på lokal/plats och kunskapsprov."
      lastReviewed={LAST_REVIEWED}
      sources={[SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26]}
      sections={[
        { h2: "Vilket tillstånd passar?", body: "För food trucks är det vanligast med tillfälligt tillstånd för enstaka tillfällen eller en avgränsad period, eller cateringtillstånd för slutna sällskap. Stadigvarande tillstånd för allmänheten kräver fast serveringsställe." },
        { h2: "Krav på plats och mat", body: "Platsen ska vara avgränsad och möjliggöra ordning och nykterhet. Från 1 juni 2026 är kraven på eget kök och varierat matutbud borttagna – matservering är inte längre ett villkor för tillståndet. Eftersom food trucks redan i grunden är matverksamheter påverkar regeländringen mest barer som vill samarbeta med en food truck." },
        { h2: "Kunskapsprov", body: "Minst en PBI måste klara kommunens kunskapsprov i alkohollagen. Öva obegränsat med Alkoholprovet." },
        { h2: "Att tänka på", body: "Sök i god tid inför varje evenemang. Vid återkommande platser – kontakta kommunen om paketlösning. Festivaler har ofta egna samordnade tillståndsprocesser." },
      ]}
      faqs={faqs}
      related={{
        title: "Relaterade sidor",
        links: [
          { to: "/serveringstillstand-och-kunskapsprov", label: "Hub – alla guider" },
          { to: "/nya-regler-serveringstillstand-2026", label: "Nya regler 2026" },
          { to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd" },
          { to: "/serveringstillstand-catering", label: "För catering" },
          { to: "/serveringstillstand-restaurang", label: "För restaurang" },
          { to: "/serveringstillstand-stockholm", label: "Serveringstillstånd Stockholm" },
          { to: "/serveringstillstand-goteborg", label: "Serveringstillstånd Göteborg" },
          { to: "/serveringstillstand-malmo", label: "Serveringstillstånd Malmö" },
          { to: "/kunskapsprov-alkohollagen", label: "Kunskapsprov i alkohollagen" },
        ],
      }}
    />
  ),
  head: () => ({
    meta: [
      { title: "Serveringstillstånd för food truck – mobil servering" },
      { name: "description", content: "Serveringstillstånd för food truck: tillfälligt tillstånd, krav på plats och mat, kunskapsprov och ansökan i kommunen." },
      { property: "og:title", content: "Serveringstillstånd för food truck" },
      { property: "og:description", content: "Tillstånd och krav för mobil servering." },
      { property: "og:url", content: "https://alkoholprovet.se/serveringstillstand-food-truck" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/serveringstillstand-food-truck" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Guider", url: "https://alkoholprovet.se/serveringstillstand-och-kunskapsprov" },
        { label: "För food truck", url: "https://alkoholprovet.se/serveringstillstand-food-truck" },
      ]),
    ],
  }),
});
